module.exports = __webpack_public_path__ + "65363c4d55617bbeb57d8ce6dcd46099.svg";